<template>
    <div style="margin-bottom: 20px;">
        <div class="baojiatitle">
            <h3 color="primary">{{ zidian.shouHuoSongHuo }}</h3>
            <Tag color="success">币别</Tag>
            <currency v-model="itemData.currency"></currency>
            <Tag color="blue">起步价（RMB）</Tag>
            <InputNumber size="small" v-model="itemData.startPirce"></InputNumber>

            <div style="margin-left: auto">
                <Button size="small" @click="
                    addTable(shouHuoSongHuoModel)
                    ">新增表格</Button>
            </div>
        </div>
        <div id="itemList" v-for="(item, row) in itemData.list" :key="row">
            <div class="fenleibiaoti">
                <Tag color="success" style="margin-right: 10px;">按区间</Tag>
                <unitBox :unit="item.unit" :units="shshunits" @on-change="unitChange(item, $event)">
                </unitBox>
                <div style="margin-left: auto">
                    <Button size="small" @click="copyTable(item)">复制表格</Button>
                    <Button size="small" @click="itemData.list.splice(row, 1)">删除表格</Button>
                    <Button size="small" @click="addQUjian(item.list)">增加区间</Button>
                    <Button size="small" @click="delQujian(item.list)">删除区间</Button>
                </div>
            </div>
            <div class="priceTable">
                <div>
                    <p>
                        <moreLine :readonly="true" v-model="item.unit"> </moreLine>
                    </p>
                    <p>
                        <start-addend-add :startAdd="item.startAdd" :endAdd="item.endAdd"
                            :transportType="item.transportType" @start="item.startAdd = $event"
                            @end="item.endAdd = $event" @transportType="item.transportType = $event"></start-addend-add>
                    </p>
                </div>
                <div v-for="(x, col) in item.list" :key="col">
                    <p>
                        <moreLine v-model="x.unit"> </moreLine>
                    </p>
                    <p>
                        <Input :border="false" size="small" v-model="x.price"></Input>
                    </p>
                </div>
            </div>
        </div>
        <div v-if="false" style="margin-bottom: 20px">
            <Tag color="error">装卸费</Tag>
            <Tag color="blue">按板</Tag>
            <InputNumber size="small" v-model="itemData.handlingPrice.pl"></InputNumber>
            元/板
            <Tag color="blue">按重量</Tag>
            <InputNumber size="small" v-model="itemData.handlingPrice.kgs"></InputNumber>
            元/kgs
            <Tag color="blue">按体积</Tag>
            <InputNumber size="small" v-model="itemData.handlingPrice.cbm"></InputNumber>
            元/cbm
        </div>
        <div>
            <Tag color="success">按地址</Tag>
            <Tag color="red">以基础报价为准，多一个地址加收单个地址价格</Tag>
            <Button size="small" @click="addFunction">新增项目</Button>
        </div>
        <Row>
            <Col style="border: solid 1px #333" span="6" v-for="(item, index) in itemData.functionList" :key="index">
            <div style="padding: 10px 10px 30px 10px;" class="paisongDDress">
                <Button icon="md-close" @click="itemData.functionList.splice(index, 1)"></Button>
                <hanshu v-model="item.function"></hanshu>
            </div>

            </Col>
        </Row>
    </div>
</template>

<script>
import modelData from "../baojia/modelData";
import unitBox from "../baojia/unitBox.vue";
import moreLine from "../baojia/moreLine.vue";
import currency from "../baojia/currency.vue";
import startAddendAdd from "../baojia/startAddendAdd.vue";
import hanshu from "../gongshi/hanshu.vue"
export default {
    props: ["data",],
    components: { unitBox, moreLine, currency, startAddendAdd, hanshu },
    data() {
        return {
            zidian: modelData.zidian,
            itemData: {
                handlingPrice: {
                    "startPirce": 0,
                    "pl": 0,
                    "kgs": 0,
                    "cbm": 0,
                    "ctn": 0
                },
                functionList: []
            },
            units: ['ff', 'dd'],
            shshunits: [
                {
                    name: "KGS",
                    select: true,
                },
                {
                    name: "CBM",
                    select: true,
                },
                {
                    name: "P/L",
                    select: true,
                },
            ],
            shouHuoSongHuoModel: modelData.shouHuoSongHuoModel
        };
    },
    methods: {
        tt() {
            this.itemData = this.data;
        },
        getVal() {
            return this.itemData;
        },//获取其他收费项目
        unitChange(item, abc) {
            var index = 0;
            for (let m = 0; m < item.unit.length; m++) {
                if (abc.name == item.unit[m]) {
                    index = m;
                }
            }
            var select = abc.select;
            var name = abc.name;
            var list = item.list;
            if (select) {
                //选中，添加回来
                item.unit.push(name);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.push("0-0");
                }
            } else {
                //取消选中。删除

                item.unit.splice(index, 1);
                for (let i = 0; i < list.length; i++) {
                    list[i].unit.splice(index, 1);
                }
            }
        },
        addTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            //list.splice(index, 0, obj);
            this.itemData.list.unshift(JSON.parse(JSON.stringify(obj)));
        },
        copyTable(v) {
            var obj = {
                name: v.name,
                startAdd: v.startAdd,
                endAdd: v.endAdd,
                unit: v.unit,
                list: v.list,
            };
            this.itemData.list.push(JSON.parse(JSON.stringify(obj)));
        },
        //增加区间
        addQUjian(v) {
            var obj = JSON.parse(JSON.stringify(v[v.length - 1]));
            v.push(obj);
        },
        //删除区间
        delQujian(v) {
            if (v.length > 1) {
                v.splice(v.length - 1, 1);
            } else {
                this.$Message.error("至少保留一个区间");
            }
        },
        addFunction() {
            this.itemData.functionList.push({
                function: "paisong(0,0,'人民币','深圳')",
            })
        }

    },
    mounted() {
        this.tt();
    },
    watch: {
        data() {
            this.tt();
        }
    }


};
</script>
<style>
.othercol {
    position: relative;
}

.new {
    /* background: #dffff0 */
}

.othercol .chox {
    position: absolute;
    bottom: 6px;
    right: 0;
}

.paisongDDress {
    position: relative;
}

.paisongDDress button {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 22;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojias/shouHuoSongHuo.vue